/**
 * Add a cookie banner overlay element, that will span the page, and prevent users
 * from interacting with page before interacting with banner
 */
export const addCookieBannerPageOverlay = () => {
    const darkFilter = document.createElement('div');
    darkFilter.classList.add('onetrust-banner-dark-filter');

    document.body.append(darkFilter);
};

/**
 * Used to reload OneTrust banner, which will be triggered when user logs in/out
 * - If user has local cookie preference, but do not have saved cookie preference on OneTrust Cloud, reloading
 *   the banner will save user's cookie preference to OneTrust Cloud
 *
 * Code taken from https://community.cookiepro.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?language=en_US
 */
export const reloadOneTrustBanner = () => {
    const otConsentSdk = document.getElementById('onetrust-consent-sdk');
    if (otConsentSdk) {
        otConsentSdk.remove();
    }

    if (window.OneTrust === null) return;

    // eslint-disable-next-line new-cap
    window.OneTrust.Init();

    setTimeout(() => {
        // eslint-disable-next-line new-cap
        window.OneTrust.LoadBanner();

        const toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings');

        for (let i = 0; i < toggleDisplay.length; i++) {
            toggleDisplay[i].onclick = (event) => {
                event.stopImmediatePropagation();
                // eslint-disable-next-line new-cap
                window.OneTrust.ToggleInfoDisplay();
            };
        }
    }, 1000);
};

/**
 * Check whether a specific cookie group is allowed
 *
 * @param cookieGroupId Cookie category to check
 * @returns {boolean|null}
 */
export const cookieGroupAllowed = (cookieGroupId) => {
    if (!window.OnetrustActiveGroups) return null;

    return window.OnetrustActiveGroups.includes(cookieGroupId);
};
